import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material'
import ImageAstDialog from './ImageAstDialog'
import { useEffect, useState } from 'react'
import { dateWithTime } from '../config'
import { useExecutionReportContext } from '../context'

export const BacklogsResume = ({
    setOpenResumeBacklogsDialog,
    openResumeBacklogsDialog,
    contenidoResumenBacklog
}) => {
    const { backlogImages } = useExecutionReportContext() || { backlogImages: {} }
    const [openImageModel, setOpenImageModel] = useState(false)
    const [indexImage, setIndexImage] = useState(0)
    const [imagesSelected, setImagesSelected] = useState([])

    const openImage = (images, index) => {
        setOpenImageModel(true)
        setImagesSelected(images)
        setIndexImage(index)
    }

    const closeImage = () => {
        setOpenImageModel(false)
        setImagesSelected([])
        setIndexImage(0)
    }

    const isOdd = (num) => {
        return num % 2
    }

    const cleanAzureUrl = (url) => {
        if (!url) return ''
        const separatorIndex = url.indexOf('?')
        return separatorIndex !== -1 ? url.substring(0, separatorIndex) : url
    }

    return (
        <Dialog
            open={openResumeBacklogsDialog}
            onClose={() => { setOpenResumeBacklogsDialog(false) }}
            sx={{
                '& .MuiDialog-container': {
                    '& .MuiPaper-root': {
                        width: '100%',
                        maxWidth: '700px',
                        height: '100%',
                        maxHeight: '600px'
                    }
                }
            }}

        >
            {openImageModel && <ImageAstDialog
                open={openImageModel}
                handleClose={closeImage}
                images={imagesSelected}
                indexSlide={indexImage}
            />}
            <DialogTitle>
                    Resumen Hallazgos
            </DialogTitle>
            <DialogContent>
                {
                    contenidoResumenBacklog &&
                        <div style={{ width: '100%', overflowY: 'auto' }}>
                            {
                                Object.keys(contenidoResumenBacklog).map((key, i) => {
                                    return (
                                        <div key={i} style={{ width: '100%', paddingBotom: 50, padding: 10, borderBottom: '1px #ccc solid', backgroundColor: isOdd(i) ? '#f0f0f0' : '#fff' }}>
                                            <p style={{ margin: '0px 5px', fontSize: 16 }}>
                                                <strong>{key}</strong>
                                            </p>
                                            <div>
                                                {
                                                    contenidoResumenBacklog[key].length === 0
                                                        ? <p style={{ margin: '0px 5px', fontSize: 14 }}>Sin datos</p>
                                                        : <div>
                                                            {
                                                                contenidoResumenBacklog[key].map((item, n) => {
                                                                    return (
                                                                        <div key={n}>
                                                                            {
                                                                                item.backlogList.map((el, z) => {
                                                                                    return (
                                                                                        <div key={z} style={{ position: 'relative', border: '1px #ccc solid', borderRadius: 8, padding: 10, marginBottom: 15, backgroundColor: '#fff' }}>
                                                                                            <p style={{ margin: '0px 0 8px 0', fontSize: 14, fontWeight: 'bold' }}>{item.taskdesc}</p>
                                                                                            {/* <p style={{ margin: '0px 5px 5px 0', fontSize: 14 }}>Hallazgo: </p> */}
                                                                                            <Grid container spacing={2}>
                                                                                                {(el.images && el.images.length > 0) &&
                                                                                                    <Grid item xs={12} sm={7}>
                                                                                                        <Grid container spacing={1}>
                                                                                                            {
                                                                                                                el.images.map((image, index) => {
                                                                                                                    let effectiveImgSrc = image?.urlBase64
                                                                                                                    if (!effectiveImgSrc) {
                                                                                                                        effectiveImgSrc = (typeof image === 'string') ? image : image?.url
                                                                                                                    }

                                                                                                                    return (
                                                                                                                        <Grid item xs={el.images.length === 1 ? 12 : 6} key={index}>
                                                                                                                            {
                                                                                                                                effectiveImgSrc
                                                                                                                                    ? <img
                                                                                                                                        src={effectiveImgSrc}
                                                                                                                                        style={{ width: '100%', maxHeight: 250, objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }}
                                                                                                                                        onClick={() => {
                                                                                                                                            openImage(el.images.map(img => {
                                                                                                                                                let srcForModal = img?.urlBase64
                                                                                                                                                if (!srcForModal) {
                                                                                                                                                    srcForModal = (typeof img === 'string') ? img : img?.url
                                                                                                                                                }
                                                                                                                                                return srcForModal
                                                                                                                                            }), index)
                                                                                                                                        }}
                                                                                                                                    />
                                                                                                                                    : <div style={{ padding: 10, border: '1px dashed #ccc', textAlign: 'center' }}>
                                                                                                                                        <p style={{ fontSize: 10, fontWeight: 'bold' }}>Error al cargar imágen.</p>
                                                                                                                                    </div>
                                                                                                                            }
                                                                                                                        </Grid>
                                                                                                                    )
                                                                                                                })
                                                                                                            }
                                                                                                        </Grid>
                                                                                                    </Grid>
                                                                                                }

                                                                                                {/* Right Side: Content */}
                                                                                                <Grid item xs={12} sm={(el.images && el.images.length > 0) ? 5 : 12}>
                                                                                                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 100 }}>
                                                                                                        <div style={{ flexGrow: 1 }}>
                                                                                                            <p style={{ margin: '0 0 4px 0', fontSize: 13, fontWeight: 'bold', color: '#be2e26' }}>
                                                                                                                {el.user ? `${el.user.name} ${el.user.lastName}` : 'Usuario Anónimo'}
                                                                                                            </p>
                                                                                                            <p style={{ margin: 0, fontSize: 15, whiteSpace: 'pre-line', color: '#333' }}>
                                                                                                                {el.message}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div style={{ textAlign: 'right', marginTop: 10 }}>
                                                                                                            <p style={{ margin: 0, fontSize: 11, color: '#777', fontStyle: 'italic' }}>
                                                                                                                {dateWithTime(el.id)}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                }
            </DialogContent>
        </Dialog>
    )
}
